// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module__cont--AEPIR{display:flex}", "",{"version":3,"sources":["webpack://./app/containers/VerticalPage/freelancers/BusinessActivity/styles.module.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA","sourcesContent":[".cont {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cont": "styles-module__cont--AEPIR"
};
export default ___CSS_LOADER_EXPORT___;
